import * as React from 'react';
import { Box, Typography, Divider, Stack, Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import { getOurSupportEmail } from "@config/config";

export default function Footer() {
  const { t } = useTranslation("footer");
  const currentYear = new Date().getFullYear();
  const supportEmail = getOurSupportEmail();

  return (
    <Box sx={{ 
      width: '100%',
      py: 3,
      mt: 'auto'
    }}>
      <Divider sx={{ mb: 2 }} />
      <Stack 
        direction={{ xs: 'column', sm: 'row' }} 
        justifyContent="space-between" 
        alignItems="center"
        spacing={2}
      >
        <Typography variant="body2" color="text.secondary">
          © {currentYear} {t("footer:copyright")}. {t("footer:allRightsReserved")}.
        </Typography>
        <Stack direction="row" spacing={3}>
          {/* <Typography variant="body2" color="text.secondary">
            {t("footer:termsOfService")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("footer:privacyPolicy")}
          </Typography> */}
          <Button 
            variant="text" 
            size="small"
            color="inherit"
            // href="mailto:contact@example.com"
            href={`mailto:${supportEmail}`}
            sx={{
              textTransform: 'none', // prevents uppercase transformation
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            <Typography variant="body2" component="span">
              {t("footer:contactUs")}
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}